import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export const ROUTES: RouteInfo[] = [
    { path: '/dashboard', title: 'Dashboard',  icon: 'ni-tv-2 text-primary', class: '' },
    { path: '/userAction', title: 'Add Event',  icon:'fa fa-calendar', class: '' },
    { path: '/gestionEvent', title: 'Getion Event',  icon:'fa fa-calendar', class: '' },
    { path: '/post', title: 'Add post',  icon:'fa fa-calendar', class: '' },
    { path: '/getAllPost', title: 'Getion Posts',  icon:'fa fa-calendar', class: '' },
   
    { path: '/sponsoring', title: 'sponsoring',  icon:'fa fa-podcast', class: '' },
    { path: '/afficheStage', title: 'Stage',  icon:'fa fa-calendar', class: '' },
    { path: '/afficheEmailNewsLaters', title: 'Email NewsLaters',  icon:'fa fa-podcast', class: '' },
    { path: '/Projet', title: 'projet',  icon:'fa fa-calendar', class: '' },
    { path: '/AfficheProjet', title: 'gerer Projet',  icon:'fa fa-calendar', class: '' },
    { path: '/addDocument', title: 'document Scientifique',  icon:'fa fa-calendar', class: '' },
    { path: '/rapport', title: 'rapport',  icon:'fa fa-calendar', class: '' }
    
   /* { path: '/icons', title: 'Icons',  icon:'ni-planet text-blue', class: '' },
    { path: '/maps', title: 'Maps',  icon:'ni-pin-3 text-orange', class: '' },
    { path: '/user-profile', title: 'User profile',  icon:'ni-single-02 text-yellow', class: '' },
    { path: '/tables', title: 'Tables',  icon:'ni-bullet-list-67 text-red', class: '' } */
];
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  public menuItems: any[];
  public isCollapsed = true;

  constructor(private router: Router) { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
   });
  }
}
